export default [
  // 学习中心
  {
    path: '/learing',
    component: () => import('@/views/pages/learing/index.vue'),
    redirect: '/learing/course',
    children: [
      {
        path: 'course',
        name: 'course',
        meta: { title: "学习中心" },
        component: () => import('@/views/pages/learing/course.vue')
      },
      {
        path: 'group',
        name: 'group',
        meta: { title: "学习中心" },
        component: () => import('@/views/pages/learing/group.vue')
      },
      {
        path: 'contest',
        name: 'contest',
        meta: { title: "学习中心" },
        component: () => import('@/views/pages/learing/contest.vue')
      },
      {
        path: 'training',
        name: 'training',
        meta: { title: "学习中心" },
        component: () => import('@/views/pages/learing/training/index.vue')
      }
    ]
  }
]
